export const environment = {
  production: false,
  authority:
    'https://login.microsoftonline.com/492ac175-0fcd-4d6c-8fde-e15c70d1986b',
  applicationClientId: '703cd66f-b551-449f-8762-3dc326fb397d',
  iServerUrl: 'https://draexlmaier-api.iserver365.com',
  redirectUri: 'https://iserver365-util.dev.devtools.draexlmaier.solutions/',
  iServerLambdaProxyUrl:
    'https://api.iserver365-util.dev.devtools.draexlmaier.solutions/',
  iServerDrxSolutionId: '8dffe181-6c83-ec11-a507-00155da3d962',
  iServerScopes: ['https://draexlmaier.iserver365.com/user_impersonation'],
  memoryApiUrl: 'https://cxxi5lnpeg.execute-api.eu-central-1.amazonaws.com',
  // AWS Bedrock Agent Core configuration
  agentCore: {
    regionName: 'eu-central-1',
    agentArn: 'arn:aws:bedrock-agentcore:eu-central-1:187296254072:runtime/IServer365UtilApp_OrbusAgent_dev-HAYUS84WHy',
  },
};
